/* eslint-disable */
const items = [
  // 1. お知らせ
  // 2. コンテナ
  {
    id: 3, // 通知
    name: "notification",
    width: 1440,
    height: 335,
    defaultHide: false
  },
  {
    id: 4, // コメント一覧
    name: "comments",
    width: 1440,
    height: 255,
    defaultHide: false
  },
  {
    id: 5, // 取引一覧
    name: "trading",
    width: 1440,
    height: 275,
    defaultHide: false
  },
  {
    id: 6, // プロセス一覧
    name: "process",
    width: 1440,
    height: 340,
    defaultHide: false
  },

  /* PB-1280対応でコメントアウト、順番入れ替え含め上にて再定義する。 */
  /*
  {
    id: 1,
    name: "calendar",
    width: 840,
    height: 360,
    defaultHide: false
  },
  {
    id: 4,
    name: "news",
    width: 408,
    height: 360,
    defaultHide: false
  },
  {
    id: 10,
    name: "comments",
    width: 408,
    height: 360,
    defaultHide: false
  },
  {
    id: 3,
    name: "trading",
    width: 840,
    height: 360,
    defaultHide: false
  },
  // {
  //   id: 5,
  //   name: "alert",
  //   width: 408,
  //   height: 360,
  // },
  {
    id: 6,
    name: "process",
    width: 840,
    height: 360,
    defaultHide: false
  },
  // {
  //   id: 8,
  //   name: "ship",
  //   width: 840,
  //   height: 360,
  // },
  // {
  //   id: 7,
  //   name: "air",
  //   width: 408,
  //   height: 360,
  // },
  {
    id: 13,
    name: "partner",
    width: 408,
    height: 360,
    defaultHide: false
  },
  {
    id: 2,
    name: "blockchain",
    width: 408,
    height: 360,
    defaultHide: true
  },
  {
    id: 12,
    name: "external",
    width: 408,
    height: 360,
    defaultHide: true
  },
  {
    id: 11,
    name: "mail",
    width: 408,
    height: 360,
    defaultHide: true
  },
  {
    id: 9,
    name: "confirmation",
    width: 408,
    height: 360,
    defaultHide: true
  },
  */
];

export default items;
